<h1 mat-dialog-title>{{TitleText}}</h1>
<div mat-dialog-content>
    <p [innerHTML]="MessageText"></p>
    <div fxLayoutAlign="center">{{timeStr}}</div>
    <mat-progress-bar mode="determinate" [value]="time"></mat-progress-bar>
</div>
<div mat-dialog-actions align="end">
    <button mat-raised-button color="primary" (click)="OKHandler()">{{OKText}}</button>
    <button mat-raised-button color="warn" (click)="CancelHandler()">{{CancelText}}</button>
</div>